import { createFileRoute } from "@tanstack/react-router";
import { AgendaMainPage } from "@/paginas/pg_agenda/agenda-main";

export const Route = createFileRoute("/_authenticated/agenda")({
  head: () => ({
    meta: [
      { title: "Agenda — Milky Moo Palmares" },
      { name: "description", content: "Agenda: visualizar e criar eventos." },
    ],
  }),
  component: AgendaMainPage,
});
